import { render, staticRenderFns } from "./CitizenForm.vue?vue&type=template&id=2033ed18&"
import script from "./CitizenForm.vue?vue&type=script&lang=js&"
export * from "./CitizenForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports